// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rv-0";